import { Button } from 'antd';
import styled from 'styled-components';
import { Cog } from '@styled-icons/boxicons-regular/Cog';

export const OpenModalButton = styled(Button)`
  display: flex;
  align-items: center;

  & > span {
    display: none;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      display: unset;
      margin-left: 0.25rem;
    }
  }

  &:hover {
    color: ${({ theme }) => theme.colors.white};
    background-color: ${({ theme }) => theme.colors.blue};
  }
`;

export const SettingsIcon = styled(Cog)`
  width: 1rem;
`;

export const ModalTitle = styled.span`
  width: 100%;
  font-size: 0.875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;

  & > div {
    display: flex;
    flex-direction: column;
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark};

    & > span {
      font-weight: 600;
    }

    & > .ant-radio-group .ant-radio-wrapper > span {
      color: ${({ theme }) => theme.colors.grayDark};
    }

    &:first-child {
      margin-bottom: 1rem;
    }
  }
`;
